import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "canh_bao_hang_ngay";

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

// moduleApi.updateHidden = (dataForm) => {
//     let api = {
//         module: moduleName,
//         type: "partialUpdate",
//         value: dataForm,
//         message: {
//             success: "Ẩn thành công", //string | null | comment
//             error: "", //string | null | comment
//         },
//     };
//     return ApiService(api);
// };

// moduleApi.updateUnHide = (dataForm) => {
//     let api = {
//         module: moduleName,
//         type: "partialUpdate",
//         value: dataForm,
//         message: {
//             success: "Hiện thành công", //string | null | comment
//             error: "", //string | null | comment
//         },
//     };
//     return ApiService(api);
// };

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

export default moduleApi;